module.exports = __webpack_public_path__ + "img/clinicaHispanaLogo.b0a6b3f0.png";